import {useMemo} from 'react'

import {ExternalLink} from '@sdox/ui'
import {extractDomain} from '@sdox/utils'

import {useBlockSiblings} from '../../hooks/useBlockSiblings'
import {useExternalLinkDisclaimerConfig} from '../../context/ExternalLinkDisclaimerContext'

import type {XcNwBlock_BlockExternalLinkType_Fragment} from '@sdox/api'

export const BlockExternalLink = (props: XcNwBlock_BlockExternalLinkType_Fragment) => {
  const {media, title, externalLinkUrl} = props
  const {next} = useBlockSiblings(props)
  const domain = useMemo(() => extractDomain(externalLinkUrl), [externalLinkUrl])

  const disclaimerConfig = useExternalLinkDisclaimerConfig()
  const showDialog = disclaimerConfig !== null && !disclaimerConfig.whiteList.includes(domain)

  return (
    <ExternalLink
      imageProps={{
        src: media.thumbnailUrl,
        placeholderSrc: media.thumbnailUrl380w,
        width: media.originalThumbnailDimensions?.width,
        height: media.originalThumbnailDimensions?.height,
      }}
      heading={title}
      showBottomBorder={next?.__typename === 'BlockExternalLinkType' || next?.__typename === 'BlockVideoWithDescriptionType'}
      source={domain}
      link={externalLinkUrl}
      dialogContent={showDialog ? disclaimerConfig.text : undefined}
    />
  )
}
